import React from 'react';

import SkeletonItem from '../../../../../components/SkeletonItem';

import './styles.scss';

const CandidateWidgetSkeleton = () => {
  return (
    <div className={'candidates__candidate'}>
      <div className={'candidate-infos'} style={{ height: '100px' }}>
        <div className={'candidate-infos__heading'}>
          <SkeletonItem style={{ height: '26px', width: '160px' }} />
        </div>
      </div>
      <div className={'candidate-options'}>
        <div className={'candidate-options__section'}>
          <SkeletonItem style={{ height: '20px', width: '200px' }} />
          <div className={'candidate-options__corrections'}>
            <div className={'candidate-options__correction'}>
              <label htmlFor="standard" className={'candidate-options__correction-label-block'}>
                <div className={'candidate-options__correction-label'}>
                  <SkeletonItem style={{ width: '85px', height: '19px' }} />
                </div>
                <div
                  className={'candidate-options__correction-description'}
                  style={{ width: '125%', height: '100px', justifyContent: 'flex-end' }}
                >
                  <SkeletonItem style={{ height: '19px', width: '50px', float: 'right' }} />
                </div>
              </label>
            </div>
            <div className={'candidate-options__correction'}>
              <label htmlFor="standard" className={'candidate-options__correction-label-block'}>
                <div className={'candidate-options__correction-label'}>
                  <SkeletonItem style={{ width: '85px', height: '19px' }} />
                </div>
                <div
                  className={'candidate-options__correction-description'}
                  style={{ width: '125%', height: '100px', justifyContent: 'flex-end' }}
                >
                  <SkeletonItem style={{ height: '19px', width: '50px', float: 'right' }} />
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateWidgetSkeleton;
